import { render, staticRenderFns } from "./DuplicateGroupDetails.vue?vue&type=template&id=5fbabe42&scoped=true&"
import script from "./DuplicateGroupDetails.vue?vue&type=script&lang=js&"
export * from "./DuplicateGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateGroupDetails.vue?vue&type=style&index=0&id=5fbabe42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbabe42",
  null
  
)

export default component.exports